import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import SoundManager from 'Engine/soundManager/SoundManager';
import eBaseEventTypes from 'Engine/enums/eBaseEventTypes';
import { makeHitArea } from 'Engine/utils/makeHitArea';
import { eSounds } from '../enums/eSounds';

export default class GameInfoControls extends FlashLib.MovieClip{
  constructor(data, displayData) {
    super(data, displayData);

    this.init();
    this.addListeners();

    this.eventMode = 'static';
    this.range = null;
    this.currentPage = 1;
  }

  init() {
    this.btnLeft = this.getChildByName('btnLeft');
    this.btnRight = this.getChildByName('btnRight');
    this.btnBack = this.getChildByName('btnBack');
    makeHitArea(this.btnLeft);
    makeHitArea(this.btnRight);
    makeHitArea(this.btnBack);
    this.btnBack.enabled = true;
  }

  addListeners() {
    this.btnLeft.on('pointertap', this.onLeftClick.bind(this));
    this.btnRight.on('pointertap', this.onRightClick.bind(this));
    this.btnBack.on('pointertap', this.onBackClick.bind(this));
  }

  checkButtonsEnabled() {
    this.btnLeft.enabled = this.range.indexOf(this.currentPage) > 0;
    this.btnRight.enabled = this.range.indexOf(this.currentPage) < this.range.length - 1;
  }

  // onBackClick() {
  //   SoundManager.play(eSounds.EST_BUTTON_CLICK.name);
  //   GlobalDispatcher.dispatch('gameInfo:backClick');
  //   GlobalDispatcher.dispatch(eBaseEventTypes.EBET_PAYTABLE__BACK_CLICK);
  //   this.reset();
  // }

  onBackClick() {
    SoundManager.play(eSounds.EST_BUTTON_CLICK.name);
    requestAnimationFrame(() => {
      GlobalDispatcher.dispatch('gameInfo:backClick');
      GlobalDispatcher.dispatch(eBaseEventTypes.EBET_PAYTABLE__BACK_CLICK);
    });
    this.reset();
  }

  onLeftClick() {
    SoundManager.play(eSounds.EST_BUTTON_CLICK.name);
    this.currentPage--;
    GlobalDispatcher.dispatch('gameInfo:changePage', this.currentPage);
    this.checkButtonsEnabled();
  }

  onRightClick() {
    SoundManager.play(eSounds.EST_BUTTON_CLICK.name);
    this.currentPage++;
    GlobalDispatcher.dispatch('gameInfo:changePage', this.currentPage);
    this.checkButtonsEnabled();
  }

  setRange(array) {
    this.range = array;
    this.checkButtonsEnabled();
  }

  reset() {
    this.currentPage = 1;
    this.checkButtonsEnabled();
  }
}
